import { useState } from "react";
import { FinancialClosing } from "store/apis/financialClosing";
import { OtherAttachmentsItem } from "./OtherAttachmentsItem";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { Preview } from "components/PreviewModal";

export type OtherFinancialsReviewPendingProps = {
  otherFinancials?: FinancialClosing["other_financials"];
};
export const OtherFinancialsReviewPending = ({
  otherFinancials,
}: OtherFinancialsReviewPendingProps) => {
  const { uuid: groupId } = useCurrentGroupContext();
  const [previewFileId, setPreviewFileId] = useState<string | null>(null);

  return (
    <div className="-t-mt-2">
      {otherFinancials?.map((item, index) => {
        return (
          <OtherAttachmentsItem
            item={item}
            key={index}
            index={index}
            onDownloadFile={setPreviewFileId}
            isLastIndex={index === otherFinancials.length - 1}
          />
        );
      })}
      <Preview
        showModal={Boolean(previewFileId)}
        closeModal={() => setPreviewFileId(null)}
        groupId={groupId}
        previewId={previewFileId}
      />
    </div>
  );
};
